import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const BASE = "https://cashflowsummit.in";

/**
 * Single source of truth for canonical URL. Renders one <link rel="canonical">
 * based on current route so it always updates when the URL changes.
 */
const CanonicalFromRoute = () => {
  const { pathname } = useLocation();
  const isBlogDetailRoute =
    pathname.startsWith("/blog/") && pathname !== "/blog/";

  if (isBlogDetailRoute) return null;

  const path = pathname === "/home" ? "/" : pathname;
  const canonical = path === "/" ? `${BASE}/` : `${BASE}${path}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};

export default CanonicalFromRoute;
